import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertDialogData } from '../../models/alert.model';
import { ConfirmAlertComponent } from './confirm-alert/confirm-alert.component';
import { DefaultAlertComponent } from './default-alert/default-alert.component';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  constructor(public dialog: MatDialog) {}

  public clearAlertAll(): void {
    this.dialog.closeAll();
  }

  public openConfirmDialog(title?: string): Promise<boolean> {
    return new Promise((resolve) => {
      const dialogRef = this.dialog.open(ConfirmAlertComponent, {
        width: '320px',
        disableClose: true,
        panelClass: 'pos-alert-dialog',
        autoFocus: false,
        data: { title: title ? title : 'กรุณายืนยัน' },
      });

      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  }

  public openDefaultDialog(params: AlertDialogData): Promise<boolean> {
    return new Promise((resolve) => {
      const dialogRef = this.dialog.open(DefaultAlertComponent, {
        width: params.width ? params.width : '300px',
        disableClose: true,
        autoFocus: false,
        panelClass: 'pos-alert-dialog',
        data: params,
      });

      dialogRef.afterClosed().subscribe(() => {
        resolve(true);
      });
    });
  }
}
